import Navbar from "../components/Navbar";
import Hero from "../components/sections/Hero";
import Marquee from "../components/sections/Marquee";
import About from "../components/sections/About";
import Numbers from "../components/sections/Numbers";
import NationalCommitment from "../components/sections/NationalCommitment";
import IndustrialServices from "../components/sections/IndustrialServices";
import SelectedProjects from "../components/sections/SelectedProjects";
import MissionVisionValues from "../components/sections/MissionVisionValues";
import Sectors from "../components/sections/Sectors";
import WhyChoose from "../components/sections/WhyChoose";
import HowWeWork from "../components/sections/HowWeWork";
import Infrastructure from "../components/sections/Infrastructure";
import Quality from "../components/sections/Quality";
import Institutional from "../components/sections/Institutional";
import ExecutionStrengths from "../components/sections/ExecutionStrengths";
import Testimonials from "../components/sections/Testimonials";
import FAQ from "../components/sections/FAQ";
import Contact from "../components/sections/Contact";
import Footer from "../components/sections/Footer";

export default function Home() {
  return (
    <main className="bg-bg-ivory text-brand-green" data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <About />
      <Numbers />
      <NationalCommitment />
      <IndustrialServices />
      <SelectedProjects />
      <MissionVisionValues />
      <Sectors />
      <WhyChoose />
      <HowWeWork />
      <Infrastructure />
      <Quality />
      <Institutional />
      <ExecutionStrengths />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
}
